(function () {
  'use strict';

  var extraDirectives = [{
    name: "wsExtraExplore",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-explore.html"
  }, {
    name: "wsExtraAdvancedConfig",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-advanced-config.html"
  }, {
    name: "wsExtraShare",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-share.html"
  }, {
    name: "wsExtraHide",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-hide.html"
  }, {
    name: "wsExtraUnhide",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-unhide.html"
  }, {
    name: "wsExtraAdopt",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-adopt.html"
  }, {
    name: "wsExtraGroup",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-group.html"
  }, {
    name: "wsExtraUngroup",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-ungroup.html"
  }, {
    name: "wsExtraDelete",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-delete.html"
  }, {
    name: "wsExtraDownload",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-download.html"
  }, {
    name: "wsExtraDashboards",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-dashboards.html"
  }, {
    name: "wsExtraRename",
    templateUrl: "modules/common/directives/card-extra/templates/card-extra-rename.html"
  }];
  angular.forEach(extraDirectives, function (extra) {
    angular.module('wsLrs.directives').directive(extra.name, [function () {
      return {
        templateUrl: extra.templateUrl,
        scope: {
          card: "=?",
          action: "=?",
          isCardGroup: "=?"
        },
        controller: function controller($scope) {
          // Added to allow some customization for "Your Reports" actions: WSLRS-9060
          $scope.isYourReportsDashboard = window.location.hash.indexOf('your-cards') > -1;
        }
      };
    }]);
  });
})();
